import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FilterableSelect, Option } from 'carbon-react/lib/components/select';
import Tooltip from 'carbon-react/lib/components/tooltip';

import { ConsolidationEntity } from '../../../../hooks/useConsolidationEntities';

interface SubEntityAutocompleteProps {
  entityFieldDisabled: boolean;
  entity?: ConsolidationEntity;
  handleSubEntityChangeCarbon: (event: React.ChangeEvent<HTMLInputElement>) => void;
  predictionContentTouched: boolean;
  entities: ConsolidationEntity[];
}

export const SubEntityAutocomplete = ({
  entityFieldDisabled,
  entity,
  handleSubEntityChangeCarbon,
  predictionContentTouched,
  entities
}: SubEntityAutocompleteProps) => {
  const intl = useIntl();

  if (entityFieldDisabled) {
    return (
      <Tooltip
        message={
          <FormattedMessage
            id="predict.entity_disabled_due_to_formula_references"
            defaultMessage="This field is disabled as your formula contains references related to the current sub-entity"
          />
        }
      >
        <div style={{ width: 320, marginRight: 8 }}>
          <FilterableSelect
            size="large"
            key="entity"
            id="entity-selector"
            label={intl.formatMessage({
              id: 'predict.sub_entity',
              defaultMessage: 'Sub-Entity'
            })}
            placeholder={intl.formatMessage({
              id: 'predict.start_typing_find_sub_entity',
              defaultMessage: 'Start typing to find your sub-entity'
            })}
            value={entity?.id || ''}
            onChange={handleSubEntityChangeCarbon}
            mb={0}
            disabled={entityFieldDisabled}
            error={predictionContentTouched && !entity ? true : false}
          >
            {entities.map((o: ConsolidationEntity) => (
              <Option key={o.id} value={o.id} text={o.fullName} />
            ))}
          </FilterableSelect>
        </div>
      </Tooltip>
    );
  }
  return (
    <div style={{ width: 320, marginRight: 8 }}>
      <FilterableSelect
        size="large"
        key="entity"
        id="entity-selector"
        label={intl.formatMessage({
          id: 'predict.sub_entity',
          defaultMessage: 'Sub-Entity'
        })}
        placeholder={intl.formatMessage({
          id: 'predict.start_typing_find_sub_entity',
          defaultMessage: 'Start typing to find your sub-entity'
        })}
        value={entity?.id || ''}
        onChange={handleSubEntityChangeCarbon}
        mb={0}
        disabled={entityFieldDisabled}
        error={predictionContentTouched && !entity ? true : false}
      >
        {entities.map((o: ConsolidationEntity) => (
          <Option key={o.id} value={o.id} text={o.fullName} />
        ))}
      </FilterableSelect>
    </div>
  );
};
